<template>
  <div class="deal-card">
    <a :href="$router.resolve({ name: 'Deal', params: { id: deal.id } }).href" class="deal-card-a">
      <b-card
        :border-variant="checked ? 'warning' : ''"
      >
        <b-card-text>
          <div>
            <b-form-checkbox
              v-model="checked"
              @input="toggleSelect"
              size="sm"
            >
              <em class="text-muted">#{{ deal.id }}</em>
            </b-form-checkbox>
          </div>
          <div>{{ deal.title }}</div>
          <div v-if="deal.contacts.length" class="deal-contacts my-1">
            <div v-for="contact in deal.contacts"
                 :key="'contact'+contact.id"
                 :data-id="contact.id"
                 class="mr-1 mb-1"
            >
              <b-card bg-variant="light">
                <b-card-text>
                  <address>
                    <div><strong>{{ contact.last_name + ' ' + contact.first_name }}</strong></div>
                    <div
                      v-if="contact.email && contact.email.trim().length>1"
                    >
                      <b-icon-envelope size="sm" class="mr-1"></b-icon-envelope>
                      <a :href="'https://admin.hyper-script.ru/crm'+$router.resolve({ name: 'Deal', params: { id: deal.id } }).href" target="_blank">{{ contact.email }}</a>
                    </div>
                    <div
                      v-if="contact.phone && contact.phone.trim().length>1"
                    >
                      <b-icon-headphones size="sm" class="mr-1"></b-icon-headphones>
                      <span>{{ contact.phone }}</span>
                    </div>
                    <div v-if="contact.chat_id">
                      <b-icon-chat size="sm"></b-icon-chat>
                      <a :href="'https://crm-telegram.hyper-script.ru/chat/'+contact.chat_id" target="_blank" class="ml-1">Telegram</a>
                    </div>
                    <div v-if="contact.metaData && contact.metaData.yandexMetrikaClientId" title="Yandex Metrika ClientID">
                      <b-icon-bar-chart size="sm"></b-icon-bar-chart>
                      <span class="ml-1">{{ contact.metaData.yandexMetrikaClientId }}</span>
                    </div>

                  </address>
                </b-card-text>
              </b-card>
            </div>
          </div>
          <div v-if="deal.company && deal.company.title">
            <b-icon-building size="xs" class="mr-1"></b-icon-building>
            <small>{{ deal.company.title }}</small>
          </div>
          <div v-if="deal.tags.length" class="deal-tags my-1">
            <b-badge v-for="tag in deal.tags"
                     :key="tag.id"
                     :data-id="tag.id"
                     variant="success"
                     class="mr-1"
            >{{ tag.title }}
            </b-badge>
          </div>
        </b-card-text>
      </b-card>
    </a>
  </div>
</template>

<script>
export default {
  name: 'deal-card',
  props: {
    deal: Object,
    checked: Boolean,
  },
  methods: {
    toggleSelect() {
      this.$emit('checkDeal', {
        id: this.deal.id,
        checked: this.checked
      });
      //console.log(this.checked);
    }
  }
}
</script>

<style scoped lang="scss">
.deal-contacts {
  address {
    margin: 0;
  }

  .card-body {
    padding: 0.25rem;

    .card-text {
      font-size: 0.9rem;
    }
  }
}

.deal-card-a {
  color: inherit;
  text-decoration: inherit;
  background-color: inherit;
}
</style>
